import { render, staticRenderFns } from "./OnboardingWorkersListWorkingHours.vue?vue&type=template&id=60acbc6e"
import script from "./OnboardingWorkersListWorkingHours.vue?vue&type=script&lang=ts"
export * from "./OnboardingWorkersListWorkingHours.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingWorkersListWorkingHours.vue?vue&type=style&index=0&id=60acbc6e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports